import React, { Fragment } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";

export const FormSubmitButton = ({ label, disabled, loading, className }) => {
  const buttonClassName = classNames("button", className, {
    "--disabled": disabled,
    "--loading": loading
  });

  return (
    <Fragment>
      <button type="submit" className={buttonClassName} disabled={disabled}>
        {label}
      </button>
    </Fragment>
  );
};

FormSubmitButton.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormSubmitButton.js